// on page anchors this can be used to jump to different sections within a page
$('body').on('click', 'a.inPageAnchor', function () {
  // Grab the target id from the metadata
  var targetId = $(this).metadata().targetId;
  ht.scrollToTarget(targetId);
  return false;
});
